import React from 'react';
import RefLastResults from '../resultPoker/RefLastResults';
import Teen8ResultBody from '../../../casinoComponents/refResultModal/Teen8ResultBody';

// Reference: every Teenpatti Open result is <span class="resulttie">R</span>
const item = () => ({ cls: 'resulttie', text: 'R' });

/** Last Result items + result modal for Teenpatti Open (teen8), reference markup. */
const ResultTeen8 = ({ data = [], gameType = 'teen8' }) => (
  <RefLastResults
    apiType={(gameType || 'teen8').toLowerCase().trim()}
    data={data}
    item={item}
    renderBody={(t1) => <Teen8ResultBody t1={t1} />}
    fallbackTitle="Teenpatti Open"
  />
);

export default ResultTeen8;
